import { render, staticRenderFns } from "./ComputedTextContent.vue?vue&type=template&id=fa19d544"
import script from "./ComputedTextContent.vue?vue&type=script&lang=js"
export * from "./ComputedTextContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports